import { render } from "./prices-popup.vue?vue&type=template&id=43a5c15e"
import script from "./prices-popup.vue?vue&type=script&lang=js"
export * from "./prices-popup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__